var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"checkbox\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Ci class=\"icon icon-dollarbird-checkmark\"\u003E\u003C\u002Fi\u003E\u003Cinput class=\"input-checkbox\" type=\"checkbox\" ng-attr-checked=\"{{ $ctrl.selected }}\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/component/checkbox/checkbox.tpl.pug
// module id = k5Qk
// module chunks = 0